import { useState } from 'react';
import { useIntl } from 'react-intl';
import { SectionHeading } from '@ets/design-system';
import ManualMetadata from './ManualMetadata/ManualMetadata';
import AutomaticMetadata from './AutomaticMetadata/AutomaticMetadata';
import styles from './Metadata.module.scss';
import { openModal } from 'App/ModalContext/utils';
import useMetadataList from '_common/hooks/useMetadataList';

const Metadata = () => {
  const intl = useIntl();
  const [selectedManualMetadata, setSelectedManualMetadata] = useState<number>(-1);
  const [selectedAutomaticMetadata, setSelectedAutomaticMetadata] = useState<number>(-1);
  const { automatic, manual } = useMetadataList();

  const openDeleteModal = (id: string, name: string) => {
    openModal({
      modal: 'DeleteMetadataModal',
      data: { id, name },
    });
  };

  return (
    <div className={styles.page}>
      <SectionHeading
        size="l"
        style={{ margin: '0 0 4rem 0' }}
        testId="manual-metadata"
        title={intl.formatMessage({ id: 'MANUAL_METADATA' })}
        firstAction={{
          variant: 'primary',
          children: intl.formatMessage({ id: 'NEW_MANUAL_METADATA' }),
          onClick: () => {
            openModal({ modal: 'ManualMetadataModal' });
          },
        }}
      />
      <ManualMetadata
        metadata={manual}
        selected={selectedManualMetadata}
        select={setSelectedManualMetadata}
        deleteMetadata={openDeleteModal}
      />
      <SectionHeading
        size="l"
        style={{ margin: '8rem 0 4rem 0' }}
        testId="automatic-metadata"
        title={intl.formatMessage({ id: 'AUTOMATIC_METADATA' })}
        firstAction={{
          variant: 'primary',
          children: intl.formatMessage({ id: 'NEW_AUTOMATIC_METADATA' }),
          onClick: () => {
            openModal({ modal: 'AutomaticMetadataModal' });
          },
        }}
      />
      <AutomaticMetadata
        metadata={automatic}
        selected={selectedAutomaticMetadata}
        select={setSelectedAutomaticMetadata}
        deleteMetadata={openDeleteModal}
      />
    </div>
  );
};

export default Metadata;
